<template>
    <v-layout  row wrap fluid class="teacher-efforts">
    <v-alert v-model="noEfforts"  icon="warning" outline>
    No efforts for the selected period.
    </v-alert>
    <v-card width="100%" v-if="hasEfforts">
        <v-toolbar dense>
            <v-toolbar-title>
                {{ teacher.firstName }} {{ teacher.lastName }} - Effort Grades
            </v-toolbar-title>
            
            <v-spacer>

            </v-spacer>
            <span v-if="this.isTeacher" ><b>{{ progressMsg }} &nbsp;</b></span>
            <v-progress-circular
            :size="35"
            :width="7"
            :rotate="360"
            :value="progress"
            :color="progressColor"
            
            >
            {{ toComplete }}
            </v-progress-circular>
            <grades-downloader :classId="this.selectedClassId" :isTeacher="true"></grades-downloader>
        </v-toolbar>
 

        <v-layout row wrap>
        <v-flex md3 sm8 class="list-pane">
            <teacher-classes-list :teacherId="$route.params.teacherId" :middleManagerId="$route.params.middleManagerId" 
                v-model="selectedClassId" ref="teacherClasses" />
        </v-flex>
        <v-flex md2 sm4 class="list-pane">
            <class-students-list :classId="selectedClassId" :teacherId="$route.params.teacherId" ref="studentList"/>
        </v-flex>
        <v-flex md7 sm12>
            
            <v-layout row centered>
                <grading-tabs v-model="efforts" :classId="selectedClassId" v-on:grade-changed="onGradeChanged" isStudent="false"
                v-on:save-failed="saveFailed" :settings="settings" :readonly="readonly" ref="_gradingTabs"
                ></grading-tabs>
            </v-layout>
        </v-flex>
        </v-layout>
    </v-card>
    </v-layout>

</template>
<script>

import { getTeacherEfforts, getMissingReportsCount, getGradingButtonsSettings } from '../utils/effort-tracking-api';
import { getItem, getPeriodHasEfforts, initialize, getPeriods, getReportingPeriodStatus } from '../utils/effort-tracking-api';
import { globalStore } from '../main.js'
import TeacherClassesList from './TeacherClassesList'
import ClassStudentsList from './ClassStudentsList'
import GradingTabs from './GradingTabs'
import GradesDownloader from './GradesDownloader'
import { store } from '../store';

export default {
    name: "teacher-efforts",
    data () { 
        return { 
            efforts: [], 
            selectedPeriod: localStorage.getItem('period-selected'),
            selectedClassId: 0,
            efforts: [],
            teacher: [],
            progress: 0,
            progressMsg: 'REPORTS TO COMPLETE',
            progressColor: 'green',
            toComplete: 0,
            isTeacher: true,
            hasEfforts: false,
            noEfforts: false,
            readonly: false,
            settings: []
        }
    },
    components: {
        TeacherClassesList, ClassStudentsList, GradingTabs, GradesDownloader
    },
    methods: {
        update() {
            var userid = store.state.userdata.id;
            var usertype = this.$store.state.usertype;
            var paramsId = this.$route.params.teacherId;
            if (userid != paramsId && usertype != 'admin' && usertype != 'middlemanager')
            {
                window.location.href = '#/users/login'
            }

            var periodId = localStorage.getItem('period-selected');
            initialize().then(x => {
                getTeacherEfforts(this.$route.params.teacherId, this.selectedClassId).then((efforts) => {
                    this.efforts = efforts;
                });
            }).catch(ex => console.log(ex));
        },
        onGradeChanged: function(data, classId){
            var student = this.$store.state.classStudents.filter(st => st.id == data.studentId)[0];
            var grades = student.grades;
            for (var i in grades) {
                if (grades[i].effortId == data.effortId) {
                    grades[i].grade = data.grade;
                    break;
                }
            }

            student.grades = grades;
            this.$refs.studentList.refresh(data, classId);
            this.$refs.teacherClasses.refresh(data, classId);
            this.update();
            this.updateProgress();
            localStorage.removeItem('saving');
        },
        saveFailed() {
            localStorage.setItem('saving', true);
        },
        load (teacherId) {
            getItem('teachers', teacherId).then((teacher) => {
                this.teacher = teacher;
            });        
        },
        updateProgress() {
            {
               getMissingReportsCount(this.selectedPeriod, this.$route.params.teacherId)
                .then(result => {
                    this.progress = 100 - (result.missing * 100 / result.all);
                    this.toComplete = result.missing;
                }).catch( ex => console.log(ex) );
            }
        },
    },
    mounted () {
        initialize().then(x => {
            this.load(this.$route.params.teacherId);
            this.updateProgress();
            this.isTeacher = (this.$store.state.usertype == 'teacher' || this.$store.state.usertype == 'middlemanager' || this.$store.state.usertype == 'admin' ? true : false );
            var periodId = localStorage.getItem('period-selected');
            var userid = this.$route.params.teacherId;

            getReportingPeriodStatus().then(result => {
                this.readonly = !result.active || result.complete;
                if (result.visible || this.$store.state.usertype == 'admin') {
                    console.log('Loading-');
                    getGradingButtonsSettings().then(sett => {
                        this.settings = sett;
                        getPeriodHasEfforts(periodId, userid).then(count => {
                            console.log('GET period has efforts: ');
                            console.log(count);

                            this.$emit('show-period-notification');
                            if (count > 0) {
                                this.hasEfforts = true;
                                this.noEfforts = false;
                            } else {
                                this.hasEfforts = false;
                                this.noEfforts = true;
                            }
                        }).catch(ex => { console.log(ex); });
                    }).catch(ex => console.log(ex));
                }
            }).catch(ex => console.log(ex));         
            
            // getGradingButtonsSettings().then(sett => { 
            //     this.settings = sett;
            //     getPeriods().then( periods => {

            //         var periodId = localStorage.getItem('period-selected');
            //         var p = periods.filter( p => Number(p.value) == periodId);

            //         if (p[0].visible || this.$store.state.usertype == 'admin')
            //         {
            //             getPeriodHasEfforts(periodId, userid).then(count => {
            //                 console.log('GET period has efforts: ');
            //                 console.log(count);

            //                 this.$emit('show-period-notification');
            //                 if(count > 0) {
            //                     this.hasEfforts = true;
            //                     this.noEfforts = false;
            //                     getReportingPeriodStatus().then(result => {  
            //                         this.readonly = !result.active || result.complete;
            //                     }).catch(ex => console.log(ex));         
            //                 } else {
            //                     this.hasEfforts = false;
            //                     this.noEfforts = true;
            //                 }
            //             }).catch(ex => {
            //                 console.log(ex);
            //             });
            //         }
            //     });
            // }).catch(ex => console.log(ex));
        });
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            var isFromMiddleManagersTab = from.name == 'MiddleManagerTeachers';
            if (to.meta.requiresResourceProperty && !isFromMiddleManagersTab && vm.$store.state.usertype == 'teacher')
            {
                if (parseInt(vm.$store.state.userdata.id) !== parseInt(vm.$route.params.teacherId))
                {
                    vm.$route.params.teacherId = vm.$store.state.userdata.id;
                    window.location.href = '#/';
                }
            }
        });
    },

    beforeRouteLeave: (to, from , next) => {
        var saving = localStorage.getItem('saving');
        if(saving != null) {
            const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
            if (answer) {
                localStorage.removeItem('saving');
                next()
            } else {
                next(false)
            }
        } else {
            localStorage.removeItem('saving');
            next();
        }    
    },
    watch: {
        selectedClassId: function() {
            this.update()
        },
        selectedPeriod: function() {
            
        },
        hasEfforts() {
            this.noEfforts = !this.hasEfforts;
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.load(this.$store.state.userdata.id);
        this.$refs.studentList.reset();
        this.$refs._gradingTabs.reset();
        next();
    },
}
</script>


// WEBPACK FOOTER //
// src/components/TeacherEfforts.vue